import React from 'react';
import PropTypes from 'prop-types';
import Masks from '../../../utils/masks';
import {
  Grid,
  Input,
  DataGrid,
} from '../../../components/index';
import * as listUtils from '../../../utils/listsSelect';
import SolicitanteDestinatario from '../SolicitanteDestinatario';

export const filterMotivos = (lista, requerimento, tipo) => {
  let motivosCessacaoFiltrado = [];
  const codigoTipo = tipo === 'aposentadoria' ? 1 : 2;

  if (requerimento.solicitante) {
    const inss = '01000';

    const destinatarioOuSolicitanteRGPS = [
      requerimento.solicitante.codigo,
      requerimento.destinatario.codigo,
    ].includes(inss);

    const acordos = destinatarioOuSolicitanteRGPS
      ? [1, 3]
      : [2, 3];

    const regimes = requerimento.solicitante.codigo === inss
      ? [1, 3]
      : [2, 3];

    motivosCessacaoFiltrado = lista.filter(motivo => (
      motivo.abrangenciaAplicavel === codigoTipo
      && regimes.includes(motivo.regimeAplicavel)
      && acordos.includes(motivo.acordoAplicavel)
    ));
  }

  return motivosCessacaoFiltrado;
};

const DadosCessacaoAposentadoria = (props) => {
  const isDestinatarioRPPS = () => {
    const { estadoFormulario } = props;
    const { requerimento, acao } = estadoFormulario;

    if (
      acao === 'realizar-analise'
      || acao === 'cumprir-exigencia'
      || acao === 'consulta'
    ) {
      return (
        requerimento.destinatario
        && requerimento.destinatario.codigo !== '01000'
        && requerimento.destinatario.codigo !== null
      );
    }

    if (acao === 'novo') {
      return (
        requerimento.destinatario !== '01000'
        && requerimento.destinatario !== null
      );
    }

    return (
      requerimento.destinatario
      && requerimento.destinatario.codigo !== '01000'
    );
  };

  const addTipoAposentadoriaLabel = (tipo) => {
    const lista = isDestinatarioRPPS()
      ? listUtils.tipoAposentadoriaRPPS
      : listUtils.tipoAposentadoriaRGPS;

    const objeto = listUtils.getObject(lista, tipo);

    return objeto ? objeto.label : '';
  };

  return (
    <React.Fragment>

      <SolicitanteDestinatario
        requerimento={props.estadoFormulario.requerimento}
      />

      <DataGrid
        title="Dados do Requerimento de Aposentadoria"
        icon="ico-money"
      >

        <div className="row">
          <Grid cols="4 4 4 4">
            <Input
              disabled
              label="Tipo da aposentadoria"
              value={addTipoAposentadoriaLabel(props.estadoFormulario.requerimento.tipoBeneficio)}
            />
          </Grid>
          <Grid cols="4 4 4 4">
            <Input
              disabled
              label="Data de Início de Benefício"
              value={props.estadoFormulario.requerimento.dataInicioBeneficio}
            />
          </Grid>
          {props.estadoFormulario.requerimento.numeroBeneficio ? (
            <Grid cols="4 4 4 4">
              <Input
                disabled
                label="NB"
                value={props.estadoFormulario.requerimento.numeroBeneficio}
              />
            </Grid>
          ) : (
            <Grid cols="4 4 4 4">
              <Input
                disabled
                label="Matrícula Regime Instituidor"
                value={props.estadoFormulario.requerimento.matricula}
              />
            </Grid>
          )}
        </div>

        <div className="row">
          <Grid cols="12 12 12 12">
            <Input
              disabled
              label="Nome"
              value={props.estadoFormulario.requerimento.nome}
            />
          </Grid>
        </div>

        <div className="row">

          <Grid cols="12 12 6 6">
            <Input
              disabled={props.estadoFormulario.desabilitarFormulario}
              label="Motivo da Cessação"
              error={!props.estadoFormulario.validadeCampos.motivoCessacao}
              touched={props.estadoFormulario.touched}
              placeholder="Selecione o motivo da cessação"
              onChange={e => props.handleChange(e, 'motivoCessacao')}
              value={props.estadoFormulario.requerimento.motivoCessacao}
              itemList={filterMotivos(
                props.motivosCessacaoRequerimento,
                props.estadoFormulario.requerimento,
                'aposentadoria',
              )}
              number
              required
              custom
            />
          </Grid>

          <Grid cols="12 12 6 6">
            <Input
              disabled={props.estadoFormulario.desabilitarFormulario}
              label="Fonte da Cessação"
              touched={props.estadoFormulario.touched}
              placeholder="Selecione a fonte da cessação"
              onChange={e => props.handleChange(e, 'fonteCessacao')}
              value={props.estadoFormulario.requerimento.fonteCessacao}
              itemList={listUtils.fonteCessacaoAposentadoria}
              number
              custom
            />
          </Grid>

        </div>

        <div className="row">
          <Grid cols="12 12 6 6">
            <Input
              disabled={props.estadoFormulario.desabilitarFormulario}
              mask={Masks.date}
              error={!props.estadoFormulario.validadeCampos.dataCessacaoBeneficio}
              label="Data da Cessação"
              onChange={e => props.handleChange(e, 'dataCessacaoBeneficio')}
              value={props.estadoFormulario.requerimento.dataCessacaoBeneficio}
              touched={props.estadoFormulario.touched}
              required
            />
          </Grid>
        </div>

        <div className="row">
          <Grid cols="12 12 12 12">
            <Input
              disabled={props.estadoFormulario.desabilitarFormulario}
              cols="74"
              componentClass="textarea"
              label="Descrição do motivo da Cessação"
              maxlength="200"
              onChange={e => props.handleChange(e, 'descricaoMotivoCessacao')}
              rows="3"
              required={[33, 35].includes(props.estadoFormulario.requerimento.motivoCessacao)}
              value={props.estadoFormulario.requerimento.descricaoMotivoCessacao}
              textarea
            />
          </Grid>
        </div>

      </DataGrid>

    </React.Fragment>
  );
};

DadosCessacaoAposentadoria.propTypes = {
  estadoFormulario: PropTypes.objectOf(PropTypes.object).isRequired,

  motivosCessacaoRequerimento: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.number,
    label: PropTypes.string,
  })),
  handleChange: PropTypes.func.isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({
      protocolo: PropTypes.string,
      acao: PropTypes.string,
      tipoRequerimento: PropTypes.string,
    }),
  }),
};

DadosCessacaoAposentadoria.defaultProps = {
  match: null,
  motivosCessacaoRequerimento: null,
};

export default DadosCessacaoAposentadoria;



// WEBPACK FOOTER //
// ./src/pages/requerimentos/Cessacao/DadosCessacaoAposentadoria.jsx